/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Nav_Go_Back_HintInputs */



/**
* | output |
* | --- |
* | "Go back (Alt + ←)" |
*
* @param {Spaces_Nav_Go_Back_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_nav_go_back_hint = /** @type {((inputs?: Spaces_Nav_Go_Back_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Nav_Go_Back_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück (Alt + ←)")
	return /** @type {LocalizedString} */ ("Go back (Alt + ←)")
});